module.exports = __webpack_public_path__ + "img/sup_cardsetting_ewalletid4.3af2a81b.jpg";